import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "inspect-single",
  "use": "inspect-single-usage",
  "viewBox": "0 0 37.55 46.39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37.55 46.39\" id=\"inspect-single\"><title>资源 25</title><g data-name=\"图层 2\"><path d=\"M34.24 0H3.31A3.31 3.31 0 0 0 0 3.31v39.76a3.31 3.31 0 0 0 3.31 3.31h30.93a3.31 3.31 0 0 0 3.31-3.31V3.31A3.31 3.31 0 0 0 34.24 0zM6.85 9.66a1.66 1.66 0 0 1 1.43-.83h8.84a1.66 1.66 0 0 1 0 3.31H8.28a1.66 1.66 0 0 1-1.43-2.48zm0 6.63a1.66 1.66 0 0 1 1.43-.83h8.84a1.66 1.66 0 1 1 0 3.31H8.28a1.66 1.66 0 0 1-1.43-2.48zM30.7 36.72a1.66 1.66 0 0 1-1.43.83h-21a1.66 1.66 0 1 1 0-3.31h21a1.66 1.66 0 0 1 1.43 2.49zm0-6.63a1.66 1.66 0 0 1-1.43.83h-21a1.66 1.66 0 1 1 0-3.31h21a1.66 1.66 0 0 1 1.43 2.49zm.22-12.43a1.1 1.1 0 0 1-1.1 1.1h-6.63a1.1 1.1 0 0 1-1.1-1.1V9.94a1.1 1.1 0 0 1 1.1-1.1h6.63a1.1 1.1 0 0 1 1.1 1.1z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/inspect-single.svg
// module id = eh8I
// module chunks = 6